// extracted by mini-css-extract-plugin
export default {"content":"technical-glitch_content__Nb0nS","parentContainer":"technical-glitch_parentContainer__z9m4A"};